module.exports = __webpack_public_path__ + "static/media/SVG_pin.63694d31.svg";